import React from 'react';

const URL_PATTERN = /(https?:\/\/[^\s)\]}>"'`]+[^\s)\]}>"'`.,;:])/g;

/** 해설 속 URL을 눌러 열 수 있는 링크로 바꿔 보여 줍니다. */
const LinkifiedText: React.FC<{ text: string }> = ({ text }) => (
  <>
    {text.split(URL_PATTERN).map((part, index) => (
      index % 2 === 1
        ? <a key={index} href={part} target="_blank" rel="noreferrer">{part}</a>
        : <React.Fragment key={index}>{part}</React.Fragment>
    ))}
  </>
);

export default LinkifiedText;
